import React, { useState, useEffect, useRef, MutableRefObject } from "react";

import useMetaSearch from "../../../shared/hooks/useMetaSearch";
import useVoiceSearch from "../../../shared/hooks/useVoiceSearch";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";

import "./searcher.scss";
import { useStaticQuery, graphql, Link } from "gatsby";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { FaTimes } from "react-icons/fa";

const Searcher = (props: SearcherInterface) => {
  const { newVoiceSearch, searchVoiceResult, isListening } = useVoiceSearch();
  const data = useStaticQuery(graphql`
    query SEARCHER_PLACEHOLDER {
      allContentfulHome(
        filter: { contentful_id: { eq: "6kJUK9wfYVkqgBk7lRrLsm" } }
      ) {
        nodes {
          tituloBuscador
          placeholdersBuscador
          titulo
          referenciaSubcategorias {
            slug
            nombreSubcategoria
          }
          id
          contentful_id
        }
      }
    }
  `);

  const placeholders = data.allContentfulHome.nodes[0].placeholdersBuscador;
  const {
    compact,
    type,
    onSelect,
    scrollIntoQuestion,
    defaultPlaceholder,
  } = props;

  const node: MutableRefObject<any> = useRef();

  const [isActive, setActiveSelect] = useState(false);
  const [dynamicPlaceholder, setDynamicPlaceholder] = useState("");
  const [searchWord, setSearchWord] = useState("");

  const { filterSearch, doSearch } = useMetaSearch(type);
  const { isBrowser, window, document } = useBrowserMode();

  const handleClickOutside = (e: Event) => {
    if (node.current.contains(e.target)) {
      return;
    } else {
      setActiveSelect(false);
    }
  };
  const handleCloseSearcher = () => {
    toogleFreeze(false);
    props.setSearcherActive(false);
    props.isMenuActive && props.setMenuActive(false);
  };

  const toogleFreeze = (isToggle: boolean) => {
    isToggle
      ? document.body.classList.add("freeze-page")
      : document.body.classList.remove("freeze-page");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && type === "comfama") {
      isBrowser &&
        searchWord.trim().length > 2 &&
        window.location.assign(
          `/resultados-busqueda/?search=${searchWord}&sort=ASC`
        );
    }
    return;
  };

  useEffect(() => {
    if (type === "comfama" || type === "headboard") {
      let cont = 0;

      const timer = setInterval(() => {
        if (cont > 2) cont = 0;
        setDynamicPlaceholder(`${placeholders[cont]}`);
        cont++;
      }, 1200);

      return () => clearInterval(timer);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isActive]);

  useEffect(() => {
    setSearchWord(searchVoiceResult.replace(/[#=&]/gi, ''));
    doSearch(searchVoiceResult.replace(/[#=&]/gi, ''));
  }, [searchVoiceResult]);

  const renderFormattedText = (text, searchWord) => {
    if (!text || !searchWord) return;
    const comparingText =
      text !== null && text.toLowerCase().indexOf(searchWord.toLowerCase());

    const formattedText =
      text !== null && comparingText !== -1 ? (
        <React.Fragment>
          {text.slice(0, comparingText)}
          <span>
            {text.slice(comparingText, comparingText + searchWord.length)}
          </span>
          {text.slice(comparingText + searchWord.length)}
        </React.Fragment>
      ) : (
        text
      );

    return formattedText;
  };

  const topics = data.allContentfulHome.nodes[0].referenciaSubcategorias;

  return (
    <div
      className={`m-searcher-container ${
        compact ? "m-searcher-container--compact" : ""
      } ${
        type === "preguntas" ? "m-searcher-container--compact-extended" : ""
      } ${type === "headboard" ? "--headboard" : ""}`}
    >
    <FaTimes
      className={`close gtmMenuTransBuscar`}
      onClick={handleCloseSearcher}
    />
      <div
        className={`m-searcher-container m-searcher-container__content ${
          isActive || searchWord.trim().length > 2
            ? "m-searcher-container__content--active"
            : ""
        }`}
      >
        <div className="m-searcher-container__input">
          <i
            className="icon icon-search"
            onClick={() =>
              isBrowser &&
              searchWord.trim().length > 2 &&
              window.location.assign(
                `/resultados-busqueda/?search=${searchWord}&sort=ASC`
              )
            }
          />
          <input
            autoFocus
            ref={node}
            value={searchWord}
            placeholder={
              type === "preguntas"
                ? "¿Qué estás buscando?"
                : defaultPlaceholder || dynamicPlaceholder
            }
            onClickCapture={() => setActiveSelect(true)}
            onChange={(text) => {
              doSearch(text.currentTarget.value.replace(/[#=&]/gi, ''));
              setSearchWord(text.currentTarget.value.replace(/[#=&]/gi, ''));
            }}
            onKeyDown={handleKeyDown}
          />
          {isListening ? (
            <i
              className="icon icon-assistive-listening-systems"
              onClick={newVoiceSearch}
            />
          ) : (
            <i className="icon icon-microphone" onClick={newVoiceSearch} />
          )}
          {searchWord.trim().length > 2 && (
            <i
              className="icon icon-times-circle1"
              onClickCapture={() => {
                setSearchWord("");
                doSearch("");
              }}
            />
          )}
        </div>
        {(searchWord.trim().length > 2 || !compact) && (
          <div className="m-searcher-container__separator" />
        )}
        {(searchWord.trim().length > 2 || !compact) && (
          <div
            className={`m-searcher-container__results ${
              searchWord.trim().length > 2 ? "" : "--hide-results"
            } ${type === "headboard" ? "--headboard-results" : ""}`}
          >
            <ul>
              {searchWord.length > 2 && filterSearch?.length === 0 && (
                <li>
                  <span className="m-searcher-results__title">
                    {`No encontramos resultados para "${searchWord.trim()}"`}
                  </span>
                </li>
              )}
              {filterSearch?.map((result, index) => {
                return (
                  <li
                    key={`result${index}`}
                    onClick={() => {
                      if (
                        onSelect !== undefined &&
                        scrollIntoQuestion !== undefined
                      ) {
                        onSelect(result);
                        setSearchWord("");
                        doSearch("");
                        scrollIntoQuestion(result.titulo);
                      }
                    }}
                  >
                    <a
                      href={
                        type === "comfama" || type === "headboard"
                          ? `${result.slug}`
                          : "#"
                      }
                      target={type === "headboard" ? "_blank" : "_self"}
                      rel="noreferrer"
                      className={`gtmResultadosPredictivo${normalizeTwoWords(
                        type === "comfama" ? result.titulo : result.tituloBanner
                      )}${normalizeTwoWords(
                        result.tipoContenido
                      )}${normalizeTwoWords(result.categoria)}`}
                    >
                      <p
                        className={`gtmResultadosPredictivo${normalizeTwoWords(
                          type === "comfama"
                            ? result.titulo
                            : result.tituloBanner
                        )}${normalizeTwoWords(
                          result.tipoContenido
                        )}${normalizeTwoWords(result.categoria)}`}
                      >
                        <span
                          className={`m-searcher-results__title 
                                       gtmResultadosPredictivo${normalizeTwoWords(
                                         type === "comfama"
                                           ? result.titulo
                                           : result.tituloBanner
                                       )}${normalizeTwoWords(
                            result.tipoContenido
                          )}${normalizeTwoWords(result.categoria)}`}
                        >
                          {renderFormattedText(
                            type === "comfama" || type === "headboard"
                              ? result.titulo
                              : result.tituloBanner,
                            searchWord
                          )}
                        </span>
                        <br />
                        <span
                          className={`m-searcher-results__subtitle
                                       gtmResultadosPredictivo${normalizeTwoWords(
                                         type === "comfama"
                                           ? result.titulo
                                           : result.tituloBanner
                                       )}${normalizeTwoWords(
                            result.tipoContenido
                          )}${normalizeTwoWords(result.categoria)}
                                 `}
                        >
                          {(type === "comfama" || type === "headboard") &&
                            renderFormattedText(
                              result.tipoContenido,
                              searchWord
                            )}
                          {(type === "comfama" || type === "headboard") && ": "}
                          {renderFormattedText(result.categoria, searchWord)}
                        </span>
                      </p>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
      <div className="m-searcher-container__categories">
        <h4>Lo más buscado</h4>
        <div className="m-searcher-container__categories-items">
          {topics.slice(0, 3).map((topic, key) => (
            <Link to={"/" + topic.slug} key={key} onClick={handleCloseSearcher}>
              <p className="m-searcher-container__categories-item">
                {topic.nombreSubcategoria}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

interface SearcherInterface {
  compact?: boolean;
  setSearcherActive: () => void;
  type?: "comfama" | "preguntas" | "headboard";
  onSelect?: Function;
  scrollIntoQuestion?: Function;
  defaultPlaceholder?: string;
}

export default Searcher;
